export const arDashboardTranslations = {
  dashboard: {
    // Dashboard page
    title: "لوحة التحكم",
    subtitle: "نظرة عامة على نشاط مطعمك",
    totalViews: "إجمالي مشاهدات القائمة",
    totalOrders: "إجمالي الطلبات",
    activeCustomers: "العملاء النشطون",
    totalRevenue: "إجمالي الإيرادات",
    menuCategories: "فئات القائمة",
    addCategory: "إضافة فئة",
    popularItems: "العناصر الشائعة",
    recentOrders: "الطلبات الأخيرة",

    // Empty states
    noCategoriesYet: "لا توجد فئات حتى الآن",
    noOrdersYet: "لا توجد طلبات حتى الآن",
    createFirstCategory: "إنشاء الفئة الأولى",

    // Charts
    viewsLabel: "المشاهدات",
    ordersLabel: "الطلبات",
    last7Days: "آخر 7 أيام",
    last30Days: "آخر 30 يومًا",
    thisMonth: "هذا الشهر",
    lastMonth: "الشهر الماضي",

    // Quick actions
    quickActions: "إجراءات سريعة",
    newMenuItem: "عنصر قائمة جديد",
    viewWebsite: "عرض الموقع",
    viewAnalytics: "عرض التحليلات",

    topCustomers: "أفضل العملاء",
    viewAllCustomers: "عرض جميع العملاء",
    viewAll: "عرض الكل",

    dashboard: "لوحة التحكم",
    welcomeTo: "مرحبًا بك في {{name}}",
    overview: "إليك نظرة عامة عن فرعك",
    totalItems: "عناصر القائمة",
    categories: "الفئات",
    mainCategories: "الفئات الرئيسية",
    subCategories: "الفئات الفرعية",
    orders: "الطلبات",
    customers: "العملاء",
    manageCategories: "إدارة الفئات",
    manageCategoriesDesc: "إنشاء وتنظيم فئات القائمة",
    manageMenu: "إدارة عناصر القائمة",
    manageMenuDesc: "إضافة وتحديث عناصر القائمة",
    viewAnalyticsDesc: "عرض التحليلات عن أداء القائمة",

    publishChanges: "نشر التغييرات",
    publishSuccess: "تم نشر القائمة بنجاح!",
    publishError: "فشل في نشر القائمة. يرجى المحاولة مرة أخرى.",

    agentSettings: "إعدادات المساعد",
    agentSettingsDesc: "تكوين المساعد الذكي وإعدادات الأتمتة",
    settings: "الإعدادات",
    settingsDesc: "إدارة إعدادات المطعم والتفضيلات",
    viewMenu: "عرض القائمة",
    viewMenuDesc: "معاينة قائمتك العامة كما يراها العملاء",
  },

  branches: {
    title: "الفروع",
    subTitle: "إدارة فروع مطعمك",
    createBranch: "إنشاء فرع",
    createFirstBranch: "إنشاء أول فرع لك",
    manageBranches: "إدارة الفروع",
    noBranches: "ليس لديك أي فروع بعد",
    untitled: "فرع بدون عنوان",
    manage: "إدارة الفرع",
    view: "عرض القائمة",
    edit: "تعديل الفرع",
    delete: "حذف الفرع",
    select: "اختيار الفرع",
    change: "تغيير الفرع",
    fetchError: "فشل في جلب الفروع. يرجى المحاولة مرة أخرى.",

    optional: "اختياري",
    logoSelected: "تم اختيار الشعار",
    uploading: "جاري الرفع...",
    supportedFormats: "PNG، JPG، WebP، GIF حتى 5 ميجابايت",
    namePlaceholder: "أدخل اسم الفرع (مثال: فرع وسط المدينة)",
    descriptionPlaceholder: "اكتب وصفاً لهذا الفرع وأي ميزات خاصة به...",
    createNew: "إنشاء فرع جديد",
    name: "اسم الفرع",
    description: "الوصف",
    logo: "الشعار",
    uploadLogo: "انقر لرفع الشعار أو اسحب وأفلت",
    create: "إنشاء الفرع",

    clone: "نسخ الفرع",
    copy: "نسخة",
    cloning: "جارٍ النسخ...",
    cloneError: "فشل في نسخ الفرع. يرجى المحاولة مرة أخرى.",
    cloneSuccess: "تم نسخ الفرع بنجاح",

    deleting: "جارٍ الحذف...",
    deleteError: "فشل في حذف الفرع. يرجى المحاولة مرة أخرى.",
    deleteSuccess: "تم حذف الفرع بنجاح",

    // Modals and confirmations
    deleteTitle: "حذف الفرع",
    deleteMessage:
      'هل أنت متأكد أنك تريد حذف "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
    deleteConfirmation:
      'هل أنت متأكد أنك تريد حذف "{{name}}"؟ سيؤدي ذلك أيضًا إلى حذف جميع البيانات في هذا الفرع. لا يمكن التراجع عن هذا الإجراء.',

    errors: {
      nameRequired: "اسم الفرع مطلوب",
      createFailed: "فشل في إنشاء الفرع. يرجى المحاولة مرة أخرى.",
      invalidFileType: "نوع الملف غير صالح. الصور فقط مسموحة.",
      fileTooLarge: "حجم الملف كبير جداً. الحد الأقصى هو 5 ميجابايت.",
    },
  },

  sidebar: {
    dashboard: "لوحة التحكم",
    menu: "عناصر القائمة",
    categories: "الفئات",
    tableManagement: "إدارة الطاولات",
    orders: "الطلبات",
    customers: "العملاء",
    dietaryPreferences: "التفضيلات الغذائية",
    variants: "المتغيرات",
    analytics: "التحليلات",
    settings: "الإعدادات",
    newMenuItem: "إضافة عنصر جديد",
    agent: "العميل",
    feedback: "التعليقات",
    menuManagement: "إدارة القائمة",
  },

  topBar: {
    search: "بحث...",
    notifications: "الإشعارات",
    noNotifications: "لا توجد إشعارات",
    viewAll: "عرض الكل",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    userMenu: "قائمة المستخدم",
  },

  notifications: {
    newOrder: "تم استلام طلب جديد!",
    menuViewed: "تمت مشاهدة قائمتك 25 مرة اليوم",
    reviewReceived: "لقد تلقيت تقييمًا جديدًا من 5 نجوم",
  },

  organizations: {
    welcome: "مرحبًا بك في مدير قوائم المطاعم",
    setupDescription: "أنشئ مؤسستك لبدء إدارة قوائم مطعمك",
    name: "اسم المؤسسة",
    namePlaceholder: "أدخل اسم مطعمك",
    createOrganization: "إنشاء المؤسسة",
  },
  menuManagement: {
    title: "إدارة القائمة",
    subtitle: "تكوين التفضيلات الغذائية والمكونات لعناصر قائمتك",
    tabs: {
      variants: "المتغيرات",
      ingredients: "المكونات",
      dietaryPreferences: "التفضيلات الغذائية"
    },
    ingredientGroups: "مجموعات المكونات",
    addIngredientGroup: "إضافة مجموعة مكونات",
    editIngredientGroup: "تعديل مجموعة المكونات",
    deleteIngredientGroup: "حذف مجموعة المكونات",
    addIngredient: "إضافة مكون",

    editIngredient: "تعديل المكون",
    deleteIngredient: "حذف المكون",
    searchIngredientsPlaceholder: "ابحث عن المكونات..."
  }

};
